import SEOHead from '../components/SEOHead'
import ContactForm from '../components/ContactForm'
import { useCmsPage } from '../hooks/useCmsPage'

export default function ForespoergselPage() {
  const { page } = useCmsPage('foresprgsel')

  const title = page?.meta_title || 'Forespørgsel — Casper DJ'
  const description =
    page?.meta_description ||
    'Send en uforpligtende forespørgsel til Casper DJ og få den perfekte musikløsning til din fest.'

  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <SEOHead title={title} description={description} />

      {/* Header */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 border-b border-neutral-900 bg-neutral-900/20 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
            Direkte forespørgsel
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
            FORESPØRGSEL
          </h1>
          <p className="text-neutral-300 text-sm sm:text-base max-w-xl mx-auto">
            Send en forespørgsel på DJ til din næste fest eller event.
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <a
              href="tel:+4530405006"
              className="p-4 rounded-2xl bg-neutral-900/60 border border-neutral-800 flex items-center gap-3 hover:border-gold-400/50 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-gold-400 text-black flex items-center justify-center shrink-0">
                <i className="fa-solid fa-phone text-sm" aria-hidden="true" />
              </div>
              <div>
                <span className="text-xs text-neutral-400 font-semibold block">Direkte telefon</span>
                <span className="text-sm font-bold text-white whitespace-nowrap">+45 30 40 50 06</span>
              </div>
            </a>

            <a
              href="mailto:INFO@CASPERDJ.DK"
              className="p-4 rounded-2xl bg-neutral-900/60 border border-neutral-800 flex items-center gap-3 hover:border-gold-400/50 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-gold-400 text-black flex items-center justify-center shrink-0">
                <i className="fa-solid fa-envelope text-sm" aria-hidden="true" />
              </div>
              <div>
                <span className="text-xs text-neutral-400 font-semibold block">Skriv direkte</span>
                <span className="text-sm font-bold text-white whitespace-nowrap">INFO@CASPERDJ.DK</span>
              </div>
            </a>
          </div>

          <ContactForm
            title="Send forespørgsel"
            subtitle="Indtast detaljer for dit arrangement, så vender jeg straks tilbage."
          />
        </div>
      </section>
    </div>
  )
}
